import { styled } from 'styled-components'

export const H2 = styled.span`
  font-family: 'CircularStdBold' !important;
  font-weight: 500;
  margin-bottom: 40px;
  font-weight: 500;
`
export const H3 = styled.h3`
  font-family: 'CircularStdMedium' !important;
  font-weight: 500;
  font-size: 24px !important;
  margin-bottom: 24px;
`
export const H4 = styled.h4`
  font-family: 'CircularStdMedium' !important;
  font-weight: 500;
  font-size: 18px !important;
  /* margin-bottom: 12px; */
`

export const Paragraph = styled.p`
  font-weight: 300;
  margin-bottom: 16px;
  font-family: 'CircularStdBook', sans-serif;
`
export const Strong = styled.strong`
  font-weight: 400;
  font-family: 'CircularStdMedium', sans-serif;
`

export const ListItem = styled.li`
  margin-bottom: 10px;
  font-size: 16px !important;
  font-weight: 400;
  font-family: 'CircularStdBook', sans-serif;
`
export const UnorderedList = styled.ul`
  list-style-type: disc;
  padding-left: 20px;
`
